import { Component } from 'react';

class Service extends Component {

  postServiceCall(url, params) {
    if (navigator.onLine) {
      if((typeof params).toLowerCase() == "string") {
        params = JSON.parse(params);
      }
      if (!params.hasOwnProperty('IsTryingToConceive')) {
        params['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
      }
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          'ftk': global.ftk,
          'uid': global.uID,
          'access-token': global.accessToken,
          'user-agent': global.userAgent,
          'isdesktop': global.isdesktop
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }
  loadJcropFiles() {
    // load css file
    var tag1 = document.createElement('link');
    tag1.href = "https://cdn.cdnparenting.com/brainbees/community/preact/public/jquery-jcrop/jquery-jcrop.css";
    tag1.rel = "stylesheet";
    document.body.appendChild(tag1);
    return new Promise(function (resolve, reject) {
      // load js file
      var script = document.createElement('script');
      script.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/jquery-jcrop/jquery-jcrop.js";
      script.addEventListener('load', function () {
        console.log("resolve js");
        resolve();
      });
      script.addEventListener('error', function (e) {
        console.log("reject js");
        reject(e);
      });
      document.body.appendChild(script);
    })
  }
  postServiceCallFC(url, params) {
    if (navigator.onLine) {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  getServiceCall(url) {
    if (navigator.onLine) {
      return fetch(url).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  postFileServiceCall(url, file, file_name) {
    if (navigator.onLine) {
      const data = new FormData()
      data.append('file', file, file_name)
      return fetch(url, {
        method: 'POST',
        body: data,
        headers: {
          'ftk': global.ftk,
          'uid': global.uID,
          'access-token': global.accessToken,
          'user-agent': global.userAgent,
          'isdesktop': global.isdesktop
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  replaceSymbols(val) {
    var mainurl = val.trim().toLowerCase();
    mainurl = mainurl.replace(/[\W_]+/g, "-");
    mainurl = mainurl.replace("---", "-");
    mainurl = mainurl.replace("--", "-");
    if (mainurl.charAt(0) == '-') {
      mainurl = mainurl.substr(1);
    }
    return mainurl;
  }

  showTracking() {
    if(document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "block";
    }
  }

  hideTracking() {
    if(document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "none";
    }
  }

  showLoader() {
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "block");
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }

  hideLoader() {
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "none");
  }

  showAlert(msg) {
    document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = msg);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "block");
    setTimeout(function () {
      document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "none");
      document.getElementsByTagName('body')[0].style.overflow = 'visible';
      document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = "");
    }, 1000);
  }

  sticky_div() {
    if (document.getElementsByClassName('registrationRight')[0]) {
      var scrollTop = window.pageYOffset;
      var div_top = document.getElementsByClassName('registrationRight')[0].offsetTop + 164;
      var left_height = document.getElementsByClassName('main-container')[0].offsetHeight;
      var right_height = document.getElementsByClassName('rightside')[0].offsetHeight;
      var footerEle = document.getElementsByClassName('footer_fclogo_text_container')[0];
      if (this.isScrolledIntoView(footerEle)) {
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
          document.getElementsByClassName('rightside')[0].classList.add('btmfixed');
        }
      } else {
        document.getElementsByClassName('rightside')[0].classList.remove('btmfixed');
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.add('stick');
        } else {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
        }
      }
    }
  }

  isScrolledIntoView(elem) {
    var docViewTop = window.pageYOffset;
    var docViewBottom = docViewTop + window.outerHeight;
    var elemTop = elem ? elem.offsetTop : 0;
    var elemBottom = elemTop;
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  loadImages() {
    var imgDefer = document.getElementsByTagName('img');
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].hasAttribute('data-src')) {
        var newsrc = imgDefer[i].getAttribute('data-src');
        imgDefer[i].setAttribute('src', newsrc);
        imgDefer[i].removeAttribute("data-src");
        imgDefer[i].onload = function () {
          this.classList.remove('loadingImg');
        };
      }
    }
  }

  slideSlider = (id, scrollVal, scrollTime) => {
    this.scrollHorizontal(document.getElementById(id), scrollVal, scrollTime);
  }

  scrollHorizontal(element, change, duration) {
    var start = element.scrollLeft,
      currentTime = 0,
      increment = 20;

    var easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  intToString(value) {
    if (!value) {
      return '0';
    } else if (isNaN(value) || parseInt(value) <= 999) {
      return value;
    } else {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
      var shortNum = shortValue;
      if (shortValue % 1 != 0) {
        shortNum = shortValue.toFixed(1);
      }
      return shortNum + suffixes[suffixNum];
    }
  }

  secondsToMS(s) {
    let m = Math.floor(s / 60);
    s -= m * 60;
    s = Math.floor(s);
    return (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s)
  }

  getUserActionPayload(childData, mycid) {
    let user_gender = 'NA';
    if (childData['UserMaster'] && childData['UserMaster']['Sex'] && childData['UserMaster']['Sex'] != "") {
      user_gender = childData['UserMaster']['Sex'];
    }
    let expecting_dob = '';
    if (childData['UserChildList'] && childData['UserChildList'].length > 0 && childData['UserChildList'][0]['IsExpected']) {
      expecting_dob = childData['UserChildList'][0]['DOB'];
    }
    let user_childinfo = [];
    if (childData['UserChildList']) {
      for (let c = 0; c < childData['UserChildList'].length; c++) {
        user_childinfo[c] = {};
        user_childinfo[c]['id'] = childData['UserChildList']['ChildId'];
        user_childinfo[c]['gender'] = childData['UserChildList']['Gender'];
        user_childinfo[c]['childdob'] = childData['UserChildList']['DOB'];
        user_childinfo[c]['isExpecting'] = childData['UserChildList']['IsExpected'];
        user_childinfo[c]['childname'] = childData['UserChildList']['ChildName'];
        user_childinfo[c]['childphoto'] = childData['UserChildList']['childPhoto'];
      }
    }
    let IsTryingToConceive = 0;
    if (childData['UserMaster']) {
      IsTryingToConceive = childData['UserMaster']['IsTryingToConceive'];
    }
    return JSON.stringify({
      "user_id": mycid,
      "expecting_dob": expecting_dob,
      "user_childinfo": user_childinfo,
      "user_gender": user_gender,
      "IsTryingToConceive": IsTryingToConceive,
      "isDesk": true
    })
  }

  validateNumber(evt) {
    var theEvent = evt || window.event;

    // Handle paste
    if (theEvent.type == 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    // var regex = /[0-9]|\./;
    var regex = /[0-9]/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  closeUserlist(event) {
    if (event.target.classList.contains('followers-overlay') || event.target.classList.contains('closeButton')) {
      this.closeUserListPopup();
    }
  }

  closeUserListPopup() {
    document.getElementsByClassName('followers-overlay')[0].style.display = 'none';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = '';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = '';
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
  }

  getUserListHTML(sData) {
    var data = JSON.parse(sData);
    console.log(data);
    var html = '';
    html += '<ul>';
    for (let i = 0; i < data.length; i++) {
      let user_desc = '';
      if (data[i].userDesc) {
        user_desc = data[i].userDesc;
      }
      if (data[i].userDescription) {
        user_desc = data[i].userDescription;
      }
      let user_id = '';
      if (data[i].UserId) {
        user_id = data[i].UserId;
      }
      if (data[i].userId) {
        user_id = data[i].userId;
      }
      let is_following = false;
      if (data[i].is_following && parseInt(is_following) == 1) {
        is_following = true;
      }
      if (data[i].isUserFollwed) {
        is_following = true;
      }
      html += '<li>';
      html += '<div class="answers-block">';
      html += '<a href=' + this.getRedirectUrl("/user-profile/" + user_id) + '>';
      html += '<div class="experts-details">';
      html += '<span class="experts-photo">';
      if (data[i].userPhoto == '' || data[i].userPhoto == null || data[i].userPhoto == undefined) {
        if (data[i].gender == "female") {
          html += '<img class="imgcheck"  src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/mother_profile.png" /></span>';
        } else if (data[i].gender == "male") {
          html += '<img class="imgcheck"  src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/father_profile.png" /></span>';
        } else {
          html += '<img class="imgcheck"  src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png" /></span>';
        }
      } else {
        html += `<img class="imgcheck" src="` + data[i].userPhoto.replace("http://", "https://") + `" onError="this.src='https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png';" /></span>`;
      }
      if (!data[i].userName || data[i].userName == "") {
        data[i].userName = "Community User"
      }
      html += '<span class="experts-name"><span class="exp-name M14_42">' + data[i].userName + '</span>';
      html += '<span class="R13_9e experts-desc">' + user_desc + '</span></span>';
      html += '</div>';
      html += '</a>';
      if (user_id != global.userAry['mycid']) {
        html += '<div class="follow-block R13_9e">';
        if (is_following) {
          html += '<span id="follow_' + user_id + '" class="likelist-unfollow" data-id="' + user_id + '">Following</span>';
        } else {
          html += '<span id="follow_' + user_id + '" class="likelist-follow" data-id="' + user_id + '">Follow</span>';
        }
        html += '</div>';
      }
      html += '</div>';
      html += '</li>';
    }
    html += '</ul>';
    return html;
  }

  followUserAction(flag, uId) {
    if (global.ftk != '') {
      this.showLoader();
      var postData = {
        "user_id": uId,
        "action_status": flag,
        "action_type": 'follow_user',
        "userPic": global.userAry['userPhoto'],
        "userName": global.userAry['userName'],
        "userGender": global.userAry['Sex'],
        "childArr": global.userAry['childData']['UserChildList']
      }
      var url = global.api_ci_url + "Parenting/saveUserFollowAction";
      this.postServiceCall(url, postData).then((json) => {
        if (json['success'] == "1") {
          var ele = document.getElementById('follow_' + uId);
          if (parseInt(flag) == 1) {
            ele.classList.remove('likelist-follow');
            ele.classList.add('likelist-unfollow');
            ele.innerHTML = 'Following';
          } else {
            ele.classList.add('likelist-follow');
            ele.classList.remove('likelist-unfollow');
            ele.innerHTML = 'Follow';
          }
        }
        this.hideLoader();
      }).catch((error) => {
        console.error(error);
        this.hideLoader();
      });
    } else {
      this.showAlert("Please Login");
      window.location.href = global.loginUrl + '?URL=' + global.currentURL;
      return false;
    }
  }

  getRedirectUrl(redirectUrl) {
    if (redirectUrl.indexOf("https://parenting.firstcry.ae") == 0) {
      redirectUrl = redirectUrl.replace("https://parenting.firstcry.ae", "");
    } else if (redirectUrl.indexOf("http://parenting.firstcry.ae") == 0) {
      redirectUrl = redirectUrl.replace("http://parenting.firstcry.ae", "");
    } else if (redirectUrl.indexOf("https://parenting.firstcry.ae") == 0) {
      redirectUrl = redirectUrl.replace("https://parenting.firstcry.ae", "");
    } else if (redirectUrl.indexOf("http://parenting.firstcry.ae") == 0) {
      redirectUrl = redirectUrl.replace("http://parenting.firstcry.ae", "");
    }
    var currentUrl = global.currentURL;
    if (currentUrl.includes('from=app')) {
      if (redirectUrl.includes('?')) {
        return redirectUrl + "&from=app";
      } else {
        return redirectUrl + "?from=app";
      }
    } else {
      return redirectUrl;
    }
  }

  onKeyPressDate(event) {
    event.returnValue = false;
    if (event.preventDefault) event.preventDefault();
  }

  onFocusDate(event) {
    var val;
    if (event.target.value && event.target.value != '') {
      val = new Date(event.target.value);
      var y = val.getFullYear();
      var m = val.getMonth() + 1;
      var d = val.getDate();
      m = m > 9 ? m : "0" + m;
      d = d > 9 ? d : "0" + d;
      var finalVal = y + '-' + m + '-' + d;
      event.target.value = finalVal;
    }
    event.target.type = "date";
    event.target.readOnly = false;
    if (event.preventDefault) event.preventDefault();
    event.target.focus();
  }

  onBlurDate(event) {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    event.target.type = "text";
    event.target.readOnly = true;
    if (event.target.value && event.target.value != '') {
      let date = new Date(event.target.value);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      event.target.value = day + " " + months[date.getMonth()] + " " + date.getFullYear();
    }
  }

  isMobile() {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  disableCutCopyPaste(id) {
    let ele = document.getElementById(id);
    if (ele) {
      ele.onpaste = e => {
        e.preventDefault();
        return false;
      };
      ele.oncopy = e => {
        e.preventDefault();
        return false;
      };
      ele.oncut = e => {
        e.preventDefault();
        return false;
      };
    }
  }

}
export default Service;



// WEBPACK FOOTER //
// src/shared/service/Service.js